import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

  public employeeDetails = new BehaviorSubject<any>(null);

  constructor() { }


}